import {DeviceConnectProvide} from "@hybird/core/device/connect";
import {DeviceEvent, DeviceProtocolBeginSealOption} from "@hybird/core/device/protocol";
import {
  DefaultDeviceProtocol,
  DefaultDeviceProtocolBeginSeal,
  DefaultDeviceProtocolOperation
} from "@hybird/device/core";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import {DeviceProvide} from "@hybird/core/device/provide";
import {DeviceType} from "@hybird/device/config";

export class DirectDeviceProvide extends DeviceProvide {

  _deviceProtocols = {
    2: DirectDeviceProtocol,
    1: DirectDeviceProtocol,
    3: DirectDeviceProtocol,
    4: DirectDeviceProtocol
  };

  constructor() {
    super(directDeviceConnectProvide);
  }

  isSupport(deviceInfo) {
    return DeviceType.seal === deviceInfo.modelType;
  }
}

export class DirectDeviceConnectProvide extends DeviceConnectProvide {
  get connected() {
    return true;
  }

  get connectType() {
    return 4;
  }

  isSupport(connectType, config) {
    return true;
  }
}

export const directDeviceConnectProvide = new DirectDeviceConnectProvide();

export class DirectDeviceProtocol extends DefaultDeviceProtocol {

  _connected = false;

  constructor(deviceProvide, deviceInfo, deviceProtocolOption = {}) {
    super(directDeviceProvide, deviceInfo, deviceProtocolOption);
    this._deviceConnectProvide = directDeviceConnectProvide;
  }

  get connected() {
    return this._connected;
  }


  async _connect({success, complete, message, fail, timeout} = {}) {
    this._connected = true;
  }

  async _disconnect({type, logout, success, complete, message, fail, timeout} = {}) {
    this._connected = false;
  }

  /**
   *
   * @param option{DeviceProtocolBeginSealOption}
   * @return {Promise<DeviceProtocolBeginSeal>}
   */
  async beginSeal({option} = {}) {
    if (!this._deviceProtocolBeginSeal || !this._deviceProtocolBeginSeal.isBeginSeal) {
      const beginSealOption = Object.assign(DeviceProtocolBeginSealOption.getInstance(this.deviceInfo), option);
      this._deviceProtocolBeginSeal = this._createDeviceProtocolBeginSeal(beginSealOption);
      this._resetBeginSealProxy();
    } else {
      this._deviceProtocolBeginSeal.option = Object.assign(DeviceProtocolBeginSealOption.getInstance(this.deviceInfo), option);
    }
    return this._deviceProtocolBeginSeal;
  }

  async operation() {
    if (!this._deviceProtocolManage) {
      this._deviceProtocolManage = this._createDeviceProtocolOperation();
      this._resetOperationProxy();
    }

    await this._deviceProtocolManage.beginSeal();
    return this._deviceProtocolManage;
  }

  _createDeviceProtocolBeginSeal(option) {
    return new DirectDeviceProtocolBeginSeal(this._deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new DirectDeviceProtocolOperation(this._deviceInfo, this);
  }
}

export class DirectDeviceProtocolBeginSeal extends DefaultDeviceProtocolBeginSeal {

  async _beginSeal({success, complete, message, fail, timeout}) {
    return {
      success: true
    }
  }

  async _endSeal({success, complete, message, fail, timeout}) {
    return {
      success: true
    }
  }

  async _equipmentLock({
                         sendEquipmentLock, success, complete, message, fail, timeout
                       }) {
    const data = await sendEquipmentLock?.call(this);

    const documentRemoteId = data.documentRemoteId;

    let clear = false;

    const onDocumentStateUploading = params => {
      params.documentRemoteId = documentRemoteId;
      this.deviceProtocol.emit(DeviceEvent.DOCUMENT_REMOTE_STATE_UPLOADING, params);
    };


    /**
     *
     * @param type 1:正常结束  2:移动取消  3:app取消
     * @return {Promise<void>}
     */
    const clearMoveEvent = async (type = 3) => {
      if (!clear) {
        clear = true;

        if (type === 2) {
          this.deviceProtocol.emit(DeviceEvent.EQUIPMENT_MOVE, {documentRemoteId});
        }

        if (type !== 1) {
          this.deviceProtocol.removeListener(DeviceEvent.DOCUMENT_STATE_UPLOADING, onDocumentStateUploading);
        }

        this.deviceProtocol.emit(DeviceEvent.EQUIPMENT_UNLOCK, {documentRemoteId, type: type});
      }
    };

    this.once(DeviceEvent.DOCUMENT_STATE_UPLOADING, onDocumentStateUploading);

    return {
      documentRemoteId, cancel: clearMoveEvent
    };
  }

  async _examineResult(documentRemoteId, state, {mode, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolBeginSeal", "examineResult", documentRemoteId, state, mode);
  }

  async _fingerprintIdentify({success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolBeginSeal", "fingerprintIdentify");
  }

  async _onSealEvent({success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolBeginSeal", "onSealEvent");
  }

  async _remoteLock({documentId, lock, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolBeginSeal", "remoteLock");
  }

  async _sealStretch({out = true, urgent, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolBeginSeal", "sealStretch");
  }
}

class DirectDeviceProtocolOperation extends DefaultDeviceProtocolOperation {

  async _beginInk({success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
  }

  async _beginInkResult({success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
  }

  async _cancelOperation({type, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _changeSeal({sealId, sealName, motion, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _changeSealFinish({sealId, sealName, type, motion, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _deviceMaintain({success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
  }

  async _fingerprintEntering({staffId, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _firmwareUpgrade({data, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _onFingerprint(type, position, auth) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _remoteLock({documentId, lock, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
  }

  async _singing({state, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
  }

  async _wifiList({onWifi, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "beginInk");
  }

  async _wifiSetting({type, save = 1, ssid, password, success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "_wifiSetting", type, save, ssid, password);
    return {
      state: 3,
      message: "无wifi配网功能"
    }
  }

  async _withInk({success, complete, message, fail, timeout}) {
    console.info("DirectDeviceProtocolOperation", "withInk");
  }
  

  async _envChange({api, iot, type, clear, success, complete, message, fail, timeout} = {}) {
    console.info("DirectDeviceProtocolOperation", "envChange", api, iot, type, clear);
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }

  async _connectChange({usbMode, success, complete, message, fail, timeout} = {}) {
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT)
  }
}


export const directDeviceProvide = new DirectDeviceProvide();